module.exports = __webpack_public_path__ + "static/img/download_certificado.1003c29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download_certificado.jpg
// module id = NWRw
// module chunks = 1